export const findOption = ( val, options ) => {
	const opt = options.find( option => option.value === val );

	return opt?.text || '--';
};
